<template>
  <div class="offer-upload">
    <b-container fluid>
      <b-row>
        <b-col class="buffer-bottom">
          <b-card>
            <b-row>
              <b-col>
                <h3>Angebote hochladen</h3>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <table class="table table-striped table-bordered" v-if="files.length">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Name</th>
                      <th>Größe</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(file, index) in files" :key="file.id">
                      <td>{{index + 1}}</td>
                      <td>
                        <div class="filename">
                          {{file.name}}
                        </div>
                        <div class="progress" v-if="file.active || file.progress !== '0.00'">
                          <div :class="{
                            'progress-bar': true, 
                            'bg-danger': file.error, 
                            'bg-success': file.success,
                            'progress-bar-animated': file.active
                          }" role="progressbar" :style="{width: file.progress + '%'}">{{file.progress}}%</div>
                        </div>
                      </td>
                      <td>{{file.size }}</td>
                      <td v-if="file.error" class="text-danger">gescheitert</td>
                      <td v-else-if="file.success" class="text-success">abgeschlossen</td>
                      <td v-else-if="file.active" class="text-info">lädt hoch...</td>
                      <td v-else></td>
                      <td>
                        <div>
                          <button 
                            class="btn btn-success btn-sm mx-1" 
                            type="button" 
                            @click.prevent="$refs.upload.update(file, {active: true})"
                            :disabled="file.active || file.progress !== '0.00'"
                          >
                            <i class="material-icons">file_upload</i>
                          </button>
                          <button 
                            class="btn btn-danger btn-sm"
                            type="button"
                            @click.prevent="removefile(index)"
                            :disabled="file.active || file.progress !== '0.00'"
                          >
                            <i class="material-icons">delete_outline</i>
                          </button>          
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </b-col>
            </b-row>
            <b-row v-if="!files.length">
              <b-col class="buffer-bottom">
                <div class="text-center p-5 mb-3" style="border:#ddd 1px solid;">
                  <h4>Word-Dokumente hierhin ziehen<br/>oder</h4>
                  <label :for="name" class="btn btn-primary">
                    <i class="material-icons">note_add</i> Dateien auswählen
                  </label>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <file-upload
                  v-show="files.length"
                  class="btn btn-primary btn-sm float-right mx-1"
                  :post-action="postAction"
                  :multiple="multiple"
                  :directory="directory"
                  :size="size || 0"
                  :thread="thread < 1 ? 1 : (thread > 5 ? 5 : thread)"
                  :drop="drop"
                  :drop-directory="dropDirectory"
                  :add-index="addIndex"
                  v-model="files"
                  @input-filter="inputFilter"
                  @input-file="inputFile"
                  ref="upload"
                >
                  <i class="material-icons">note_add</i> Weitere hinzufügen
                </file-upload>
                <a 
                  href="/admin/offer-list" 
                  class="btn btn-sm  float-right" 
                  :class="{
                    'btn-secondary': !ready,
                    'btn-success': ready
                  }"
                >
                  <i class="material-icons">arrow_back</i> Zurück zur Übersicht
                </a>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>


<script>

import FileUpload from 'vue-upload-component';
import Config from '../misc/Config';
import Auth from '../misc/Auth';

export default {
  components: {
    FileUpload,
  },
  name: "OfferUpload",
  data() {
    return {
      files: [],
      minSize: 1024,
      size: 1024 * 1024 * 10,
      multiple: true,
      directory: false,
      drop: true,
      dropDirectory: true,
      addIndex: false,
      thread: 3,
      name: 'file',
      postAction: Config.API_URL + '/containers/myfile/upload?access_token=' + Auth.authKey() ,
      autoCompress: 1024 * 1024,
      uploadAuto: false,
      addData: {
        show: false,
        name: '',
        type: '',
        content: '',
      }
    }
  },
  computed: {
    ready() {
      if(this.files.length === 0) {
        return false;
      }
      return this.files.every(file => parseInt(file.progress) === 100);
    }
  },
  methods: {
    inputFilter(newFile, oldFile, prevent) {
      if (newFile && (!oldFile || newFile.file !== oldFile.file)) {
        newFile.blob = ''
        let URL = window.URL || window.webkitURL
        if (URL && URL.createObjectURL) {
          newFile.blob = URL.createObjectURL(newFile.file)
        }
      }
    },
    /**
     * what was it good for dunno
     * @todo remove in next version
     */
    // inputFile(newFile, oldFile) {
    //   if (newFile && oldFile) {
    //   }
    // },
    
    onAddFolder() {
      if (!this.$refs.upload.features.directory) {
        this.alert('Your browser does not support')
        return
      }

      let input = this.$refs.upload.$el.querySelector('input')
      input.directory = true
      input.webkitdirectory = true
      this.directory = true

      input.onclick = null
      input.click()
      input.onclick = (e) => {
        this.directory = false
        input.directory = false
        input.webkitdirectory = false
      }
    },

    onAddData() {
      this.addData.show = false
      if (!this.$refs.upload.features.html5) {
        this.alert('Your browser does not support')
        return
      }

      let file = new window.File([this.addData.content], this.addData.name, {
        type: this.addData.type,
      })
      this.$refs.upload.add(file)
    },

    removefile(index) {
      this.files.splice(index, 1);
    }
  }
}
</script>

<style>
.example-full .btn-group .dropdown-menu {
  display: block;
  visibility: hidden;
  transition: all .2s
}
.example-full .btn-group:hover > .dropdown-menu {
  visibility: visible;
}

.example-full label.dropdown-item {
  margin-bottom: 0;
}

.example-full .btn-group .dropdown-toggle {
  margin-right: .6rem
}



.example-full .filename {
  margin-bottom: .3rem
}

.example-full .btn-is-option {
  margin-top: 0.25rem;
}
.example-full .example-foorer {
  padding: .5rem 0;
  border-top: 1px solid #e9ecef;
  border-bottom: 1px solid #e9ecef;
}


.example-full .edit-image img {
  max-width: 100%;
}

.example-full .edit-image-tool {
  margin-top: .6rem;
}

.example-full .edit-image-tool .btn-group{
  margin-right: .6rem;
}

.example-full .footer-status {
  padding-top: .4rem;
}

.example-full .drop-active {
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  position: fixed;
  z-index: 9999;
  opacity: .6;
  text-align: center;
  background: #000;
}

.example-full .drop-active h3 {
  margin: -.5em 0 0;
  position: absolute;
  top: 50%;
  left: 0;
  right: 0;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  font-size: 40px;
  color: #fff;
  padding: 0;
}
.btn.btn-sm .material-icons {
  padding-bottom: 0px;
}
.btn .material-icons {
  vertical-align: bottom;
  padding-bottom: 2px;
}
.offer-upload {
  margin-top: 15px;
}
h3 {
  margin-top:8px;
  margin-bottom: 22px;
}
a.btn-primary {
  color:white;
}
.btn .material-icons{
  cursor: pointer;
  font-size: 1.2em;
  vertical-align: middle;
}
a.btn {
  color: white;
}
</style>